module.exports = __webpack_public_path__ + "img/header.7a1ee674.png";